import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { FaqLayoutComponent } from './faq.layout';
import { FaqComponent } from './faq.component';


export const routes: Routes = [
  {
    path: '',
    component: FaqLayoutComponent,
    children: [
       {
        path: '',
        component:FaqComponent
       }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FaqRoutingModule {
}
